export enum AlertType {
    Info = 'info',
    Warn = 'warn',
    Error = 'error',
}
